import { render, staticRenderFns } from "./MemberModal.vue?vue&type=template&id=68b1ec70"
import script from "./MemberModal.vue?vue&type=script&lang=js"
export * from "./MemberModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports